<template>
  <div class="about">
    <h1>This is an home page</h1>
  </div>
</template>